const destinations = [
  { name: 'Kenya', flag: 'https://blueberry.azureedge.net/WillMars/Kenya.svg' },
  { name: 'Tanzania', flag: 'https://blueberry.azureedge.net/WillMars/Tanzania.svg' },
  { name: 'Zambia', flag: 'https://blueberry.azureedge.net/WillMars/Zambia.svg' },
  { name: 'Mozambique', flag: 'https://blueberry.azureedge.net/WillMars/Mozambique.svg' },
  { name: 'Namibia', flag: 'https://blueberry.azureedge.net/WillMars/Namibia.svg' },
  { name: 'Mali', flag: 'https://blueberry.azureedge.net/WillMars/Mali.svg' },
  { name: 'India', flag: 'https://blueberry.azureedge.net/WillMars/India.svg' },
  { name: 'London', flag: 'https://blueberry.azureedge.net/WillMars/London.svg' },
  { name: 'Mexico City', flag: 'https://blueberry.azureedge.net/WillMars/Mexico_city.svg' },
  { name: 'Uzbekistan', flag: 'https://blueberry.azureedge.net/WillMars/Uzbekistan.svg' },
]

function Reach() {
  return (
    <section className="reach" id="reach">
      <div className="wrap">
        <div className="section-head reach-head">
          <div className="eyebrow">Our reach</div>
          <h2>
            <span className="intro-title-line">Rooted in Africa.</span>
            <span className="intro-title-line">Connected globally.</span>
          </h2>
          <p>From our offices in Nairobi and Dar es Salaam, we serve clients across Africa and connect regional requirements with appropriate expertise and capacity in international reinsurance markets.</p>
        </div>
        <div className="markets">
          {destinations.map((item) => (
            <div className="market" key={item.name}>
              <img src={item.flag} alt="" width="28" height="28" />
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Reach
